"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDrivers = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateDriver_1 = require("./StateDriver");
class StateDrivers extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Drivers", true);
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateDriver_1.StateDriver);
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
            this.page.ctrls.btnNew.hide();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const drivers = yield this.lockgui(this.app.api.admin.directory.getDrivers());
            if (!drivers)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(drivers);
            return _super.start.call(this);
        });
    }
    fill(drivers) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = '';
            for (const driver of drivers) {
                const item = new com.ListItem();
                item.ctrls.lType.text = "Driver";
                item.ctrls.lId.text = `#${driver.userShort.id}`;
                let data = [gs.text.clearHtmlToText(`Name: ${driver.userShort.name} ${driver.userShort.surname}`),
                    gs.text.clearHtmlToText(`License: ${driver.driver.driverLicense.substring(0, 15)}...`)];
                if (driver.company.id)
                    data.push(gs.text.clearHtmlToText(`Company: ${driver.company.shortName}`));
                item.ctrls.pData.html = data.join('<br>');
                this.page.ctrls.list.append(item);
                if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.DriverControl))
                    item.onclick = () => gs_1.StateGS.Run(StateDriver_1.StateDriver, driver);
            }
        });
    }
}
exports.StateDrivers = StateDrivers;
StateDrivers.StateName = "drivers";
//# sourceMappingURL=StateDrivers.js.map